module.exports = "<p>\n  登録完了！！！👍\n</p>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/homePC/angular-comp/yarukami/src/app/top/completed/completed.component.html
// module id = ../../../../../src/app/top/completed/completed.component.html
// module chunks = main